import { favouritesEl } from './favourites'
import './routeplanner.js'
import { favouritesListElement } from './artistutils';

/* Handle the favourite artists list block */

export class FavouriteArtists {
    constructor(list) {
        this.list = list
        this.routemap = list.querySelector(".route-map");
    }

    init() {
        this.initFavourites()
        this.handleDragDrop()
        this.createMap()
    }

    createMap() {
        const el = document.createElement('route-map');
        this.routemap.appendChild(el);
        this.map = el;
    }

    initFavourites() {


        // Sort
        const artists = this.list.querySelector(".artists")
        const favourites = favouritesEl.favourites
        const elements = Array.from(artists.querySelectorAll('.artist'));
        if (elements.length) {
            elements.sort((a, b) => {
                // Convert dataset strings to integers
                const idA = parseInt(a.dataset.artistid, 10);
                const idB = parseInt(b.dataset.artistid, 10);

                let indexA = favourites.indexOf(idA);
                let indexB = favourites.indexOf(idB);

                // Rule: If an ID is not found in favourites, push it to the very end of the list
                if (indexA === -1) indexA = Infinity;
                if (indexB === -1) indexB = Infinity;

                return indexA - indexB;
            })

            // 1. Group items by their value, and keep track of empty items
            const groups = {};
            const finalOrder = [];

            elements.forEach(el => {
                const num = el.dataset.listingnumber;
                if (num && num.trim() !== '') {
                    if (!groups[num]) groups[num] = [];
                    groups[num].push(el);
                }
            });

            // 2. Build the final array by placing groups at their LAST original occurrence
            elements.forEach(el => {
                const num = el.dataset.listingnumber;

                if (!num || num.trim() === '') {
                    // Keep empty items exactly where they originally were
                    finalOrder.push(el);
                } else if (groups[num]) {
                    // Check if this is the last time this number appears in the original list
                    const isLastOccurrence = el === groups[num][groups[num].length - 1];
                    if (isLastOccurrence) {
                        // Dump the entire matching group right here
                        finalOrder.push(...groups[num]);
                        delete groups[num]; // Clear it so we don't process it again
                    }
                }
            });

            artists.innerHTML = '';
            elements.forEach(element => {
                artists.appendChild(element)
                element.addEventListener("click", (e) => {
                    if (!favouritesEl.clickedOnItinerary(e, element.querySelector(".logo"))) {
                        window.location = element.dataset.artisturl
                    }
                })
            });


            // Handle clear button
            const btnClear = this.list.querySelector(".clear")
            btnClear.addEventListener("click", (e) => {
                this.map.clearAll()
                favouritesEl.clearFavourites()
                btnClear.style.display = "none"
                this.list.style.display = "none"
            })
            // No clear btn when no artists
            if (!elements.length) {
                btnClear.style.display = "none"
                this.list.style.display = "none"
            }

            // No clear button after last artist is removed
            const list = this.list
            document.addEventListener(favouritesEl.removeEventName, (e) => {
                const artists = list.querySelector(".artists")
                const elements = Array.from(artists.querySelectorAll('.artist'))
                const artistId = e.detail.artistId
                let others = 0
                elements.forEach(el => {
                    if (el.dataset.artistid != artistId) {
                        others++
                    }
                })
                if (others == 0) {
                    btnClear.style.display = "none"
                    this.list.style.display = "none"
                }
            })
        } else {
            this.list.style.display = "none"
        }
    }

    handleDragDrop() {
        let draggingElement = null;

        // 1. Activate dragging ONLY when interacting with the handle
        this.list.addEventListener('mousedown', (e) => {
            if (e.target.classList.contains('sort-handle')) {
                const item = e.target.closest('.artist');
                item.setAttribute('draggable', 'true');
            }
        });

        // 2. Disable dragging once the click/drag action releases
        this.list.addEventListener('mouseup', (e) => {
            if (e.target.classList.contains('sort-handle')) {
                const item = e.target.closest('.artist');
                item.removeAttribute('draggable');
            }
        });

        // 3. Track the element that started the drag event
        this.list.addEventListener('dragstart', (e) => {
            draggingElement = e.target.closest('.artist');
            if (draggingElement) {
                draggingElement.classList.add('dragging');
            }
        });

        // 4. Clean up states when the drag operation stops
        this.list.addEventListener('dragend', (e) => {
            if (draggingElement) {
                draggingElement.classList.remove('dragging');
                draggingElement.removeAttribute('draggable');
                draggingElement = null;
            }
            const favourites = []
            this.list.querySelectorAll(".artist").forEach(artist => {
                favourites.push(parseInt(artist.dataset.artistid))
            })
            favouritesEl.setFavourites(favourites)
        });

        // 5. Calculate and apply the new sorting order dynamically
        this.list.addEventListener('dragover', (e) => {
            e.preventDefault(); // Required to allow dropping

            const targetItem = e.target.closest('.artist');
            if (!targetItem || targetItem === draggingElement) return;

            // Determine if the cursor is above or below the middle of the target item
            const bounding = targetItem.getBoundingClientRect();
            const offset = e.clientY - bounding.top;
            const isAfter = offset > bounding.height / 2;

            // Insert the element before or after the targeted item
            if (isAfter) {
                targetItem.after(draggingElement);
            } else {
                targetItem.before(draggingElement);
            }
        });
    }

}
const listEl = favouritesListElement();
if (listEl) {
    const fa = new FavouriteArtists(listEl);
    fa.init()
}